import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import contactNoteDialogService from 'services/contactNoteDialogService';
import { ClientRepresentativeResponse } from 'types/LegalPartner';
import { EnvConfig } from 'config/envConfig';

export const useGetClientRepresentative = (label: string, enable = true) => {
  return useQuery<ClientRepresentativeResponse, AxiosError>({
    queryKey: ['useGetClientRepresentative', label],
    queryFn: async ({ signal }) => contactNoteDialogService.getClientRepresentative(label, signal),
    enabled: enable && label.length > 0,
    select: (data) => {
      if (EnvConfig.config.enablePshApiUpdate) {
        return {
          ...data,
          hits: data.hits.map((hit) => ({
            ...hit,
            dob: hit.dateOfOrigin,
          })),
        };
      }
      return data;
    },
  });
};
